export default {
  state: {
    inputType: "password",
    eyeState: "hidden",
  },
  mutations: {
    TOGGLE_EYE_STATE: (state) => {
      if (state.inputType === "password") {
        state.inputType = "text";
        state.eyeState = "visible";
      } else {
        state.inputType = "password";
        state.eyeState = "hidden";
      }
    },
  },
  actions: {
    toggleEyeState({ commit }) {
      commit("TOGGLE_EYE_STATE");
    },
  },
};
